<template>
	<div>
		<div class="d-flex align-center justify-space-between">
			<p class="mb-0 font-weight-bold">{{listingTitle}}</p>
			<v-btn
				dark
				x-small
				color="success"
				v-if="showAddButton"
				@click="addNew"
			>
				<v-icon small dark>mdi-plus</v-icon>
				<p class="mb-0 ml-2 caption">Nuevo</p>
			</v-btn>
		</div>
		<v-divider class="my-1"></v-divider>
		<v-list class="pt-0" style="max-height: 300px;max-width: 600px;overflow: scroll;">
			<draggable
				v-model="titles"
				handle=".handle_drag"
				@end="startEndDragTitleEvent">
				<v-list-item
					v-for="(item, i) in titles"
					:key="i"
					class="px-0 py-0"
				>
					<div style="width: 100%">
						<div class="d-flex flex-row px-2 pt-2 justify-space-between">
							<div class="d-flex flex-row align-center caption">
								<v-icon class="handle_drag mr-2">mdi-unfold-more-horizontal</v-icon>
								<p class="mb-0 caption font-weight-bold" style="color: #707070;">{{ item.title || item.subtitle }}</p>
							</div>
							<div class="d-flex align-center">
								<v-tooltip bottom>
									<template v-slot:activator="{ on, attrs }">
										<v-btn
											icon
											dark
											x-small
											color="success"
											v-if="itemSelected"
											@click="itemSelected(item)"
											v-bind="attrs"
											v-on="on"
										>
											<v-icon small dark>{{ isItemSelected(item) ? 'mdi-sticker-check-outline' : 'mdi-sticker-outline' }}</v-icon>
										</v-btn>
									</template>
									<span>Asignar</span>
								</v-tooltip>
								<v-tooltip bottom>
									<template v-slot:activator="{ on, attrs }">
										<v-btn
											icon
											dark
											x-small
											color="warning"
											@click="setTitle(item)"
											v-bind="attrs"
											v-on="on"
										>
											<v-icon small dark>mdi-pencil</v-icon>
										</v-btn>
									</template>
									<span>Editar</span>
								</v-tooltip>
								<v-tooltip bottom>
									<template v-slot:activator="{ on, attrs }">
										<v-btn
											icon
											dark
											x-small
											color="error"
											@click="deleteTitle(item)"
											v-bind="attrs"
											v-on="on"
										>
											<v-icon small dark>mdi-delete-outline</v-icon>
										</v-btn>
									</template>
									<span>Eliminar</span>
								</v-tooltip>
							</div>
						</div>
					</div>
				</v-list-item>
			</draggable>
		</v-list>
	</div>
</template>

<script>
import _debounce from 'lodash/debounce'
import draggable from 'vuedraggable'
import { updateOrderTitleBudget, deleteBudgetTitle } from '@/helpers/api/budgets'
import { updateOrderTitleReport, deleteReportTitle } from '@/helpers/api/reports'
import { updateOrderTitleContract, updateOrderSubtitleContract, deleteContractTitle, deleteContractSubtitle } from '@/helpers/api/contracts'

export default {
	name: 'TitlesListingMenu',
	components: {draggable},
	props: {
		type: {
			type: String,
			default: 'budget'
		},
		section: {
			type: Object,
			required: true
		},
		itemSelected: {
			type: Function,
			required: false
		},
		showAddButton: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		listingTitle(){
				if (this.type === 'budget') {
					return 'Títulos para Presupuesto'
				} else if (this.type === 'report') {
					return 'Títulos para Informe'
				} else if (this.type === 'contract') {
					return 'Títulos para Contrato'
				} else if (this.type === 'contract_subtitle') {
					return 'Subtítulos para Contrato'
				}
				return ''
		},
		titles: {
			get() {
				if (this.type === 'budget') {
					return this.$store.state.budget.companiesBudgetTitles
				} else if (this.type === 'report') {
					return this.$store.state.reports.companiesReportTitles
				} else if (this.type === 'contract') {
					return this.$store.state.contracts.titleContracts
				} else if (this.type === 'contract_subtitle') {
					return this.$store.state.contracts.subtitleContracts
				}
				return []
			},
			set(value) {
				if (this.type === 'budget') {
					this.$store.commit('budget/setCompaniesBudgetTitles', value)
				} else if (this.type === 'report') {
					this.$store.commit('reports/setCompaniesReportTitles', value)
				} else if (this.type === 'contract') {
					this.$store.commit('contracts/setTitleContracts', value)
				} else if (this.type === 'contract_subtitle') {
					this.$store.commit('contracts/setSubtitleContracts', value)
				}
			}
		}
	},
	methods: {
		addNew(){
			if(this.type == 'contract' || this.type == 'contract_subtitle'){
				const newItem = {
					isTitle: this.type == 'contract',
					isSubtitle: this.type == 'contract_subtitle',
				}
				this.$store.commit('contracts/setNewContractTitleModalEditing', newItem)
			}
			this.$store.commit('contracts/setNewContractTitleModal', true)
		},
		startEndDragTitleEvent: _debounce(function(){ this.endDragTitleEvent() }, 500),
		async endDragTitleEvent(){
			const titles = this.titles.map((prefix, index) => {
				return {id: prefix.id, order: index + 1}
			})
			if(this.type === 'budget'){
				await updateOrderTitleBudget({titles})
				this.$store.dispatch('budget/getBudgetTitles')
			}
			else if(this.type === 'report'){
				await updateOrderTitleReport({titles})
				this.$store.dispatch('reports/getReportTitles')
			}
			else if(this.type === 'contract'){
				await updateOrderTitleContract({titles})
				this.$store.dispatch('contracts/getContractTitles')
			}
			else if(this.type === 'contract_subtitle'){
				await updateOrderSubtitleContract({titles})
				this.$store.dispatch('contracts/getContractTitles')
			}
		},
		setTitle(title = null){
			if(this.type === 'budget'){
				this.$store.commit('budget/setNewBudgetTitleModalEditing', title ? {...title, ...{budget_title_id: title.id}}:null)
				this.$store.commit('budget/setNewBudgetTitleModal', true)
			}
			else if(this.type === 'report'){
				this.$store.commit('reports/setNewReportTitleModalEditing', title ? {...title, ...{report_title_id: title.id}}:null)
				this.$store.commit('reports/setNewReportTitleModal', true)
			}
			else if(this.type === 'contract'){
				this.$store.commit('contracts/setNewContractTitleModalEditing', title ? {...title, ...{contract_title_id: title.id, isTitle: true, isSubtitle: false}}:null)
				this.$store.commit('contracts/setNewContractTitleModal', true)
			}
			else if(this.type === 'contract_subtitle'){
				this.$store.commit('contracts/setNewContractTitleModalEditing', title ? {...title, ...{contract_subtitle_id: title.id, title: title.subtitle, isTitle: false, isSubtitle: true}}:null)
				this.$store.commit('contracts/setNewContractTitleModal', true)
			}
		},
		async deleteTitle(title){
			if(this.type === 'budget'){
				await deleteBudgetTitle({budget_title_id: title.id})
				this.$store.dispatch('budget/getBudgetTitles')
			}
			else if(this.type === 'report'){
				await deleteReportTitle({report_title_id: title.id})
				this.$store.dispatch('reports/getReportTitles')
			}
			else if(this.type === 'contract'){
				await deleteContractTitle({contract_title_id: title.id})
				this.$store.dispatch('contracts/getContractTitles')
			}
			else if(this.type === 'contract_subtitle'){
				await deleteContractSubtitle({contract_subtitle_id: title.id})
				this.$store.dispatch('contracts/getContractTitles')
			}
		},
		isItemSelected(item) {
			if (this.type === 'contract' || this.type === 'budget' || this.type === 'report') {
				return this.section.title === item.title
			} else if (this.type === 'contract_subtitle') {
				return this.section.subtitle === item.title
			}
			return false
		}
	}
}
</script>